import { Line } from "recharts";

const BaseLine = Line

export default BaseLine